var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.notificationsShow
    ? _c("div", { staticClass: "popup", staticStyle: { position: "fixed" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.contentShow,
                expression: "contentShow"
              }
            ],
            staticClass: "notifiy-content",
            staticStyle: { position: "fixed" },
            attrs: { id: "notifications" }
          },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\r\n                " +
                  _vm._s(_vm.$t("language.rightTopBanner.notification")) +
                  "\r\n                "
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                attrs: { id: "dialogClose" },
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "notification-content" }, [
              _c("div", {
                attrs: { id: "notificationContainer" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("language.popup.addCloudPopup.notificationTip")
                  )
                }
              }),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "8.8.5"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2026/5/31"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v885")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "8.8.4"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2026/4/30"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.improvedLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v884")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "8.8.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2026/1/19"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.improvedLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v881")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "8.8.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2025/12/31"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v880")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "8.7.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2025/10/31"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.improvedLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v870")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "8.3.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2025/5/30"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.noteLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v831")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "8.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2025/3/15"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v830")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.8.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2025/2/28"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v780")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.6.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2025/2/24"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.improvedLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v760")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.5.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2025/1/15"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.improvedLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v750")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.4.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2024/12/31"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _c("br"),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v740")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2024/12/27"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _c("br"),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v730")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2024/11/08"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v720")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.1.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2024/06/27"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v710")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("b", [
                _vm._v(
                  _vm._s(_vm.$t("language.popup.addCloudPopup.notAbleAccess"))
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t("language.popup.addCloudPopup.problemNotAccess")
                  )
                )
              ]),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.0.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2024/05/09"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v700")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "6.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2024/02/29"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v630")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "6.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2024/01/30"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v620")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "5.5.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2023/09/11"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v550")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "5.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2023/06/30"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v530")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "5.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2023/05/31"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v520")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "5.0.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2023/03/15"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v500")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.9.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2023/02/14"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v490")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.8.7"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2022/07/07"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v487")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.8.5"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2022/06/08"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v485")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.8.2"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2022/05/30"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v482")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.8.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2022/01/20"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v480")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.7.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2021/11/05"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v470")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.6.8"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2021/09/30"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v468")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.6.7"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.releasedOn")) +
                      "2021/07/01"
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.newLabel"))
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v467")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.6.5"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v465")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.7"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v457")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.6"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v456")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.5"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v455")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.4"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v454")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.3"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v453")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.2"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v452")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v451")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v450")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.4.4"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v444")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.4.3"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v443")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.4.2"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v442")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.4.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v441")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.4.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v440")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.3.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v431")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v430")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v420")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.1.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v410")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.0.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v400")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.8.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v380")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.7.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v370")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.6.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v360")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.5.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v350")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.4.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v340")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v330")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v320")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.1.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v310")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.0.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v300")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.3.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v231")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v230")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.2.2"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v222")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.2.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v221")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v220")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.1.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v210")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.0.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.addCloudPopup.notif_v200")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("br")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "notificate-footer" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    float: "left",
                    position: "relative",
                    top: "8Px",
                    "line-height": "30Px"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.checkBox()
                    }
                  }
                },
                [
                  _c("span", {
                    staticClass: "icon-util  notification-check-position",
                    class: _vm.check ? "check-small" : "nocheck-small",
                    attrs: { id: "checkIcon" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.checkBox()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "notice-text" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.popup.addCloudPopup.noPrompt"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticStyle: {
                    float: "right",
                    "margin-right": "10Px",
                    width: "110Px",
                    position: "relative",
                    top: "8Px"
                  },
                  on: {
                    click: function($event) {
                      return _vm.sure()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.okButton"))
                  )
                ]
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56b3c4ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b3c4ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/notifications_popup.vue
// module id = null
// module chunks = 